// extracted by mini-css-extract-plugin
export default {"section":"NotFound_section__RMgN6"};